import React, { useCallback } from "react";
import { useCart } from "../../context/CartContext";
import { Link } from "react-router-dom";
import { FiTrash2 } from "react-icons/fi";

function CartItemsInCart({ item }) {
  const { updateQuantity, removeItem } = useCart();

  const {
    _id,
    thumbnail: image,
    slug,
    title,
    variantName,
    quantity,
    price,
    subtotal,
    mrp,
  } = item;

  const numPrice = Number(price);
  const numMrp = Number(mrp);

  const handleRemove = useCallback((e) => {
    e.preventDefault(); // Browser navigation or form submit block karne ke liye
    removeItem(_id);
  }, [removeItem, _id]);

  const handleQuantityChange = useCallback(
    (e, delta) => {
      e.preventDefault(); // 🔥 IMPORTANT: Form reload or submit event block karne ke liye
      
      const newQuantity = quantity + delta;
      if (newQuantity < 1) return;

      updateQuantity(_id, newQuantity);
    },
    [updateQuantity, _id, quantity],
  );

  return (
    <tr className="funky-order-row">
      {/* 1. PRODUCT METRICS & PORTRAIT IMAGE */}
      <td>
        <div className="cart-product-item-box">
          <div className="cart-img-small-72x94">
            <Link to={slug}>
              <img src={image} alt={title} />
            </Link>
          </div>
          
          <div className="cart-item-details">
            <Link to={slug} className="cart-item-name-link">
              {title}
            </Link>
            {variantName && <span className="cart-variant-badge">{variantName}</span>}
            <button type="button" className="cart-remove-action-btn mt-2" onClick={handleRemove}>
              <FiTrash2 className="me-1" /> Remove
            </button>
          </div>
        </div>
      </td>

      {/* 2. MRP LINE-THROUGH */}
      <td>
        {!isNaN(numMrp) ? (
          <span className="cart-mrp-strike-text">
            ₹{numMrp.toFixed(2)}
          </span>
        ) : (
          <span className="cart-mrp-strike-text">--</span>
        )}
      </td>

      {/* 3. OUR PRICE */}
      <td>
        <span className="price-text-funky">
          ₹{numPrice.toFixed(2)}
        </span>
      </td>

      {/* 4. QUANTITY MINIMAL COUNTER BOX */}
      <td>
        <div className="cart-qty-align">
          <div className="qty-counter-minimal-box">
            {/* type="button" add kiya h explicitly taaki form triggers standard behavior follow na karein */}
            <button
              type="button" 
              className="qty-btn-trigger"
              onClick={(e) => handleQuantityChange(e, -1)}
            >
              -
            </button>
            <input
              className="qty-input-display"
              type="text"
              value={quantity}
              readOnly
            />
            <button
              type="button"
              className="qty-btn-trigger"
              onClick={(e) => handleQuantityChange(e, 1)}
            >
              +
            </button>
          </div>
        </div>
      </td>

      {/* 5. SUBTOTAL */}
      <td className="text-end">
        <span className="price-text-funky text-purple-accent">
          ₹{subtotal.toFixed(2)}
        </span>
      </td>
    </tr>
  );
}

export default CartItemsInCart;